import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.config.matrixDefinitions.xero', {
    amaxPayBankAccountFieldName: 'Bank account',
    allowToRemoveLinesFromBP: 'Allow to remove lines from the Batch Payment',
});
